import React from 'react';

import CSSModules from 'react-css-modules';

import Heading from '../../TextComponents/Heading';

import styles from './styles.module.scss';

type MetaProps = {
  title: string;
  duration: string;
  section: string;
};

const Meta = ({title, duration, section}: MetaProps): JSX.Element => (
  <div styleName='step'>
    <div>
      <div styleName='lessonNumber'>{section && <span>{section}</span>}</div>
      <div styleName='moduleTitle'>
        <Heading as='h4' size='sheep' weight='medium'>
          {title}
        </Heading>
      </div>
      <div styleName='durationContainer'>
        <img src='/resources/img/icn_time.svg' />
        <span>{duration}</span>
      </div>
    </div>
  </div>
);

export default CSSModules(Meta, styles);
